import { fg } from '@atlaskit/platform-feature-flags/fg';

export const QUICK_ACTION_AGENT_ATTRIBUTION_FEATURE_GATE =
	'platform_editor_quick_action_attribution';

export const isQuickActionAgentAttributionEnabled = (): boolean =>
	fg(QUICK_ACTION_AGENT_ATTRIBUTION_FEATURE_GATE);
